<template>
    <div id="home">
        <tico-logo></tico-logo>
        <div class="about">Complete the form below to offset the greenhouse gas emissions associated with your everyday living, and support a Native American carbon project.</div>
        <form id="yearEstimateForm" @submit="formSubmit">
            <ul id="yearEstimateFormList" class="calculator-form-list">
                <li class="calculator-form-item">
                    <h3 class="calculator-form-title">People in Home</h3>
                    <div class="form-icon"><i class="fas fa-user-friends"></i></div>
                    <input type="number" min="0" v-model.number="occupants" placeholder="Number of People in Home" required>
                    <div class="form-error" v-if="occupants < 0">Cannot be a negative number</div>
                </li>
                <li class="calculator-form-item">
                    <h3 class="calculator-form-title">Electricity</h3>
                    <div class="form-icon"><i class="fas fa-bolt"></i></div>
                    <input type="number" min="0" v-model.number="electricity" placeholder="Annual Electricity Use in kWh" required>
                    <div class="form-error" v-if="electricity < 0">Cannot be a negative number</div>
                </li>
                <li class="calculator-form-item">
                    <h3 class="calculator-form-title">Natural Gas</h3>
                    <div class="form-icon"><i class="fas fa-burn"></i></div>
                    <input type="number" min="0" v-model.number="natural_gas" placeholder="Annual Natural Gas Use in Therms" required>
                    <div class="form-error" v-if="natural_gas < 0">Cannot be a negative number</div>
                </li>
                <li class="calculator-form-item">
                    <h3 class="calculator-form-title">Propane</h3>
                    <div class="form-icon"><i class="fas fa-fire-alt"></i></div>
                    <input type="number" min="0" v-model.number="propane" placeholder="Annual Propane Use in Gallons" required>
                    <div class="form-error" v-if="propane < 0">Cannot be a negative number</div>
                </li>
                <li class="calculator-form-item">
                    <h3 class="calculator-form-title">Fuel Oil</h3>
                    <div class="form-icon"><i class="fas fa-oil-can"></i></div>
                    <input type="number" min="0" v-model.number="fuel_oil" placeholder="Annual Fuel Oil Use in Gallons" required>
                    <div class="form-error" v-if="fuel_oil < 0">Cannot be a negative number</div>
                </li>
                <li class="calculator-form-item">
                    <h3 class="calculator-form-title">Miles</h3>
                    <div class="form-icon"><i class="fas fa-route"></i></div>
                    <input type="number" min="0" v-model.number="distance" placeholder="Annual Miles Driven" required>
                    <div class="form-error" v-if="distance < 0">Cannot be a negative number</div>
                </li>
                <li class="calculator-form-item">
                    <h3 class="calculator-form-title">MPG</h3>
                    <div class="form-icon"><i class="fas fa-gas-pump"></i></div>
                    <input type="number" min="1" v-model.number="mpg" placeholder="Average MPGs of Vehicles" required>
                    <div class="form-error" v-if="mpg <= 0 && mpg !== null">MPG must be greater than 0</div>
                </li>
            </ul>
            <div id="formButtonWrap"><button class="button-submit" id="yearEstimateSubmit"><span><span class="title">Find your footprint</span> See your estimated carbon emissions</span></button></div>
        </form>
    </div>
</template>

<script>
    import Vuex from "vuex";
    import TicoLogo from "../shared/tico-logo.vue";

    export default {
        name: "GeneralLivingForm",
        components: {TicoLogo},
        data() {
            return {
                formError: false
            };
        },
        computed: {
            ...Vuex.mapState(["generalLivingFormData"]),
            electricity: {
                get() { return this.generalLivingFormData.electricity; },
                set(value) { this.$store.commit("generalLivingFormData/setElectricity", value); }
            },
            natural_gas: {
                get() { return this.generalLivingFormData.natural_gas; },
                set(value) { this.$store.commit("generalLivingFormData/setNaturalGas", value); }
            },
            propane: {
                get() { return this.generalLivingFormData.propane; },
                set(value) { this.$store.commit("generalLivingFormData/setPropane", value); }
            },
            fuel_oil: {
                get() { return this.generalLivingFormData.fuel_oil; },
                set(value) { this.$store.commit("generalLivingFormData/setFuelOil", value); }
            },
            occupants: {
                get() { return this.generalLivingFormData.occupants; },
                set(value) { this.$store.commit("generalLivingFormData/setOccupants", value); }
            },
            distance: {
                get() { return this.generalLivingFormData.distance; },
                set(value) { this.$store.commit("generalLivingFormData/setDistance", value); }
            },
            mpg: {
                get() { return this.generalLivingFormData.mpg; },
                set(value) { this.$store.commit("generalLivingFormData/setMpg", value); }
            }
        },
        methods: {
            formSubmit(e) {
                e.preventDefault();
                let valid = this.occupants !== null && this.occupants >= 0 &&
                    this.electricity !== null && this.electricity >= 0 &&
                    this.natural_gas !== null && this.natural_gas >= 0 &&
                    this.fuel_oil !== null && this.fuel_oil >= 0 &&
                    this.distance !== null && this.distance >= 0 &&
                    this.mpg !== null && this.mpg > 0;
                this.formError = !valid;
                if (valid) {
                    this.formError = false;
                    this.$router.push("living/contribute");
                }
            }
        }
    };
</script>

<style scoped lang="less">
    @import (reference) "../../assets/variables";
</style>



// WEBPACK FOOTER //
// src/components/general-living-calculator/GeneralLivingForm.vue